import { render } from "./DirectorioStreamlined.vue?vue&type=template&id=132fd8a8&scoped=true"
import script from "./DirectorioStreamlined.vue?vue&type=script&lang=ts"
export * from "./DirectorioStreamlined.vue?vue&type=script&lang=ts"

import "./DirectorioStreamlined.vue?vue&type=style&index=0&id=132fd8a8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-132fd8a8"

export default script